export const consideredSpam = (spamStatus: SpamStatus) => {
  if (spamStatus === 'SUSPECTED_SPAM' || spamStatus === 'USER_REPORTED_SPAM') {
    return true;
  }

  return false;
};
